import { ReactElement } from 'react';
import React from 'react';

import RGLogo from '@/assets/icons/rgLogo';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { common } from '@/styles/styles';
import { SpacingProps } from '@shopify/restyle';

import RichText, { ParsedTypes } from './RichText';
import { Box } from './lib/components';
import { AppTheme } from './lib/theme';

export const DEFAULT_FOOTER_MARGIN_TOP = 's80';

export const FooterRG = ({ marginTop = DEFAULT_FOOTER_MARGIN_TOP, ...props }: SpacingProps<AppTheme>): ReactElement => {
    const accountFooter = useJurisdictionStore(
        state => state.jurisdictionSettings?.globalSettings?.richTextsSlices?.AccountFooter
    );

    return (
        <Box
            paddingVertical="s24"
            paddingHorizontal="s16"
            alignItems="center"
            gap="s16"
            backgroundColor="background.neutral.subtler"
            borderWidth={1}
            borderColor="border.subtle"
            borderRadius="r20"
            style={common.borderCurve}
            marginTop={marginTop}
            marginBottom="s48"
            {...props}
        >
            <RGLogo />
            <Box>
                <RichText
                    data={accountFooter ?? []}
                    typeProps={{
                        [ParsedTypes.BR]: { value: 4 },
                        [ParsedTypes.H1]: { variant: 'titleLarge', letterSpacing: -0.43 },
                    }}
                />
            </Box>
        </Box>
    );
};
